import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { SSR_CATEGORIES } from "../../helpers/ssrCategories";

const countLabel = (label, count, bold = false) => (
  <span style={{ display: "flex", alignItems: "center" }}>
    <Typography
      variant="body2"
      sx={{ mr: 0.5, fontWeight: bold ? "bold" : "normal" }}
    >
      {label}
    </Typography>
    <Typography component="span" variant="caption">
      ({count})
    </Typography>
  </span>
);

export const SpecialNeedsFilter = ({
  count,
  categoryCounts,
  checked,
  selectedCategories,
  onParentToggle,
  onCategoryToggle,
}) => {
  const selected = selectedCategories || [];
  const visible = SSR_CATEGORIES.filter(
    (category) => (categoryCounts?.[category.key] || 0) > 0
  );

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            name="SPECIAL_NEEDS"
            onChange={(event) => onParentToggle(event.target.checked)}
          />
        }
        label={countLabel("Special needs", count, true)}
      />
      {checked && visible.length > 0 ? (
        <Box sx={{ pl: 3.5, pb: 0.5 }}>
          {visible.map((category) => (
            <FormControlLabel
              key={category.key}
              control={
                <Checkbox
                  checked={selected.includes(category.key)}
                  name={category.key}
                  onChange={(event) =>
                    onCategoryToggle(category.key, event.target.checked)
                  }
                />
              }
              label={countLabel(
                category.label,
                categoryCounts[category.key] || 0
              )}
            />
          ))}
        </Box>
      ) : null}
    </FormGroup>
  );
};
